"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeUrl = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
const http_interfaces_1 = require("../types/http.interfaces");
const time_management_1 = require("./time-management");
/** Composes final url */
const composeUrl = (send, endpointsSet, managerContext) => async (request) => {
    const { baseUrl, baseUrlPromise } = endpointsSet;
    const baseUrlStep = request.operationLogger.logStep(http_interfaces_1.OperationLogEntryType.BaseUrlResolve);
    const finalBaseUrl = baseUrl ||
        (baseUrlPromise &&
            (await (0, time_management_1.timed)(baseUrlPromise().catch((e) => {
                throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.BaseUrlFailedToResolve, undefined, e);
            }), managerContext.globalContext, managerContext.configuration.baseUrlResolutionTimeoutInMs, error_interfaces_1.ErrorReason.BaseUrlTimeout)));
    try {
        if (finalBaseUrl) {
            /**
             * URL's constructor has some interesting behavior if the base url contains a path component:
             *
             * - If a base url has a path, it needs to end with a forward slash, otherwise the path
             *   being appended to the base url will be appended after the last forward slash in the base url. For example,
             *   new URL("three/four", "https://developer.mozilla.org/one/two") will result in a URL with a value of
             *   "https://developer.mozilla.org/one/three/four", where new URL("three/four", "https://developer.mozilla.org/one/two/")
             *   will result in "https://developer.mozilla.org/one/two/three/four"
             *
             * - If the path to append begins with a forward slash, any path components in the base URL will be completely ignored regardless
             *   if the base url ends with a forward slash:
             *   new URL("/three/four", "https://developer.mozilla.org/one/two") and new URL("/three/four", "https://developer.mozilla.org/one/two/")
             *   will both result in URL objects with a value of "https://developer.mozilla.org/three/four"
             *
             * Therefore, in order to avoid unwanted behavior in consuming code, we should ensure that the base URL ends with a forward slash AND
             * the path to append does not begin with a forward slash before combining them into a new URL. This will result in a combined URL
             * with the expected value while removing the burden of doing the exact correct thing from consuming code.
             */
            const baseUrlWithEndingSlash = !finalBaseUrl.endsWith("/") && request.url.length > 0
                ? `${finalBaseUrl}/`
                : finalBaseUrl;
            const pathWithoutStartingSlash = request.url.startsWith("/")
                ? request.url.substring(1)
                : request.url;
            request.url = new URL(pathWithoutStartingSlash, baseUrlWithEndingSlash).href;
        }
    }
    catch (e) {
        throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.InvalidUrl);
    }
    baseUrlStep && baseUrlStep({ result: http_interfaces_1.Status[http_interfaces_1.Status.OK] });
    return send(request);
};
exports.composeUrl = composeUrl;
